import { render } from "./otherOpen.vue?vue&type=template&id=1c1d3385"
import script from "./otherOpen.vue?vue&type=script&lang=js"
export * from "./otherOpen.vue?vue&type=script&lang=js"

import exportComponent from "E:\\newyear\\chatgpt\\chat-bot-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__